export const middleOfDay = (date: Date) => {
  const middleOfDay = new Date(date);
  middleOfDay.setHours(12, 0, 0, 0);
  return middleOfDay;
};
